import { POPUP_UNFINISHED_SEEN, POPUP_DIPLOMA_SEEN } from './actions';
import { LOGIN_LOGOUT } from '../auth/actions';

const initialState = {
  popupUnfinishedSeen: false,
  popupDiplomaSeen: false,
};

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case POPUP_UNFINISHED_SEEN:
      return { ...state, popupUnfinishedSeen: true };
    case POPUP_DIPLOMA_SEEN:
      return { ...state, popupDiplomaSeen: true };
    case LOGIN_LOGOUT:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
